lodash = require('lodash')

CANNOT_LINK_DOCUMENT = 'This document is already linked to another document. No documents can be linked to it.'

module.exports = (
  $scope,
  $uibModalInstance,
  document,
  projectPermissions,
  projectStarredDocs,
  starredDocs,
  Api
) ->

  _getErrorMessage = (doc, starredDocs) ->
    for _, sDoc of starredDocs
      if doc.id in sDoc.linked_documents
        return CANNOT_LINK_DOCUMENT
    return null

  $scope.setErrorMessage = () ->
    $scope.errorMessage = _getErrorMessage($scope.doc, $scope.starredDocs)
    $scope.error = $scope.errorMessage?

  $scope.filterDocumentsByIds = (document_ids) ->
    results = []
    for _, doc of $scope.starredDocs
      if doc.id in document_ids
        results.push(doc)
    return results

  $scope.filterStarredDocs = (starredDocs) ->
    all_linked_documents_ids = []
    for _, doc of $scope.starredDocs
      if doc.linked_documents.length > 0
        all_linked_documents_ids.push(doc.id)
      for id in doc.linked_documents
        all_linked_documents_ids.push(id)
    linked_documents_ids = all_linked_documents_ids.filter((value, index, self) -> self.indexOf(value) == index)

    results = []
    for _, doc of $scope.starredDocs
      already_linked = doc.id in linked_documents_ids
      not_self = doc.id != $scope.doc.id
      if not already_linked and not_self
        results.push doc
    return results

  $scope.linkDocument = (doc) ->
    if doc and doc.id
      $scope.linkedDocuments.push doc
      linked_documents_ids = (x.id for x in $scope.linkedDocuments)
      push_link = new Api.ProjectStarredDocument {id: $scope.doc.id, linked_documents: linked_documents_ids}
      push_link.$update()
      document.linked_documents = linked_documents_ids
      $scope.selectedDoc = {}

  $scope.unlinkDocument = (doc) ->
    lodash.remove $scope.linkedDocuments, (linked) ->
      linked.id == doc.id
    linked_documents_ids = (x.id for x in $scope.linkedDocuments)
    push_link = new Api.ProjectStarredDocument {id: $scope.doc.id, linked_documents: linked_documents_ids}
    push_link.$update()
    document.linked_documents = linked_documents_ids

  $scope.selectedDoc = {}

  $scope.cancel = ->
    $uibModalInstance.close()
    return

  $scope.doc = document
  $scope.projectPermissions = projectPermissions
  $scope.projectStarredDocs = projectStarredDocs
  $scope.starredDocs = starredDocs
  $scope.setErrorMessage()
  $scope.linkedDocuments = $scope.filterDocumentsByIds(document.linked_documents)
